/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { capsFirstLetter } from "../../util/functions"
import NewCategoryModal from "./Categories/NewCategoryModal"
import EditCategoryModal from "./Categories/EditCategoryModal"

function CategoriesPanel() {
  const [categories, setCategories] = useState([])
  const [curCategory, setCurCategory] = useState({})
  const [refresh, setRefresh] = useState(true)

  /* =========================
     DELETE CATEGORY
  ========================= */
  const deleteCategory = async (id) => {
    const found = categories.find((c) => c._id === id)
    const categoryName = found?.name || "Unknown"

    if (
      !window.confirm(
        `⚠️ Delete Category ⚠️\nAre you sure you want to delete this category?\n\n` +
          `${categoryName}\n\nThis action cannot be undone.`,
      )
    ) {
      return
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/categories/${id}`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        },
      )

      const data = await res.json()

      if (!res.ok) {
        console.error(data)
        alert("Failed to delete category")
        return
      }

      setRefresh(true)
    } catch (err) {
      console.error("Delete error:", err)
      alert("Something went wrong")
    }
  }

  /* =========================
     FETCH CATEGORIES
  ========================= */
  useEffect(() => {
    const getCategories = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/categories`)
        const data = await res.json()

        if (refresh) {
          setCategories(Array.isArray(data) ? data : [])
          setRefresh(false)
        }
      } catch (err) {
        console.error("Fetch categories error:", err)
      }
    }

    getCategories()
  }, [refresh])

  /* =========================
     RENDER
  ========================= */
  return (
    <div className="CategoriesPanel col-12 d-flex flex-column align-items-center">
      <div className="col-12 text-start ms-3">
        <h3 className="display-4 col-12 text-center">Categories:</h3>

        {/* ACTION BAR */}
        <div
          className="col-lg-6 col-md-8 col-sm-10 d-flex flex-row justify-content-center mx-auto my-3"
          style={{ marginEnd: "-10px" }}
        >
          <div className="col-6"></div>
          <div className="col-6 d-flex justify-content-end">
            <button
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#newCategoryModal"
              type="button"
            >
              Create new category
            </button>
          </div>
        </div>

        {/* CATEGORY LIST */}
        {categories.map((c) => (
          <div
            key={c._id}
            className="ap-cat-card col-lg-6 col-md-8 col-sm-10 d-flex flex-row justify-content-center mx-auto my-3"
            style={{ minWidth: "600px" }}
          >
            {/* IMAGE */}
            <div className="col-3 d-flex justify-content-center align-items-center border p-3 bg-light">
              <img
                src={c.image || c.images?.[0] || "/placeholder.png"}
                className="img-fluid"
                alt={c.name || "category"}
              />
            </div>

            {/* DETAILS */}
            <div className="ap-cat-card-inner col-9 flex-row align-items-center d-flex border ps-3 pe-4">
              <div className="ap-cat-card-title col-6 fs-3">
                {capsFirstLetter(c.name)}
              </div>

              {/* EDIT */}
              <button
                className="col-3 btn btn-primary me-2"
                data-bs-toggle="modal"
                data-bs-target="#editCategoryModal"
                type="button"
                onClick={() => setCurCategory(c)}
              >
                Edit
              </button>

              {/* DELETE */}
              <button
                className="col-3 btn btn-danger"
                onClick={() => deleteCategory(c._id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}

        {/* MODALS */}
        <NewCategoryModal setRefresh={setRefresh} />

        <EditCategoryModal
          refresh={refresh}
          category={curCategory}
          setCategory={setCurCategory}
          setRefresh={setRefresh}
        />
      </div>
    </div>
  )
}

export default CategoriesPanel
